// extracted by mini-css-extract-plugin
export default {"container":"SuccessDefaultV2_container__-Y3v0","content":"SuccessDefaultV2_content__H-WtV"};